import { IconButton } from "components";
import { StatusChip } from "features/shared/components/StatusChip";
import React from "react";
import { getTableTypicalColumn } from "utils/components";

type ConfigStatusColumnOptions<Row> = {
  configuredLabel: string;
  dataKey: keyof Row & string;
  isConfigured: (row: Row) => boolean;
  label: string;
  notConfiguredLabel: string;
};

export const getConfigStatusColumn = <Row extends Record<string, unknown>>({
  configuredLabel,
  dataKey,
  isConfigured,
  label,
  notConfiguredLabel,
}: ConfigStatusColumnOptions<Row>) =>
  getTableTypicalColumn({
    dataKey,
    isReadOnly: true,
    label,
    valueTransformation: (row: Row) => {
      const configured = isConfigured(row);
      return (
        <StatusChip variant={configured ? "info" : "error"}>
          {configured ? configuredLabel : notConfiguredLabel}
        </StatusChip>
      );
    },
  });

type ConfigActionColumnOptions<Row> = {
  configureLabel: string;
  isConfigureDisabled?: (row: Row) => boolean;
  minWidth?: string;
  onConfigure: (row: Row) => void;
};

export const getConfigActionColumn = <Row extends Record<string, unknown>>({
  configureLabel,
  isConfigureDisabled,
  minWidth,
  onConfigure,
}: ConfigActionColumnOptions<Row>) =>
  getTableTypicalColumn({
    dataKey: "config",
    isReadOnly: true,
    label: configureLabel,
    minWidth,
    valueTransformation: (row: Row) => (
      <IconButton
        buttonProps={{
          disabled: isConfigureDisabled?.(row),
          onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            onConfigure(row);
          },
          size: "sm",
          variant: "tertiary",
        }}
        iconProps={{ iconName: "Settings", size: "sm" }}
      />
    ),
  });

export const getTechnicalConfigToastError = (error: { response?: { data?: unknown } }) =>
  JSON.stringify(error?.response?.data);
